import {
  resolveOutputPath,
  stringifyOutputPathValue,
} from "@/flow/utils/outputPathResolver";

export function getTooltipforOutput(values, list) {
  if (list === undefined || list === null || list.length === 0) return "";
  if (values.length === 0) {
    return stringifyOutputPathValue(list);
  }

  const resolved = resolveOutputPath(list, values);
  return resolved.found ? stringifyOutputPathValue(resolved.value) : "";
}

export function getTooltipForMetaoutput(value, index, metaoutputList) {
  const metaoutput = metaoutputList.find((item) => item.index === index);
  if (metaoutput !== undefined) {
    try {
      const selectedMetaoutput = JSON.parse(metaoutput.metaoutput);
      const resolved = resolveOutputPath(selectedMetaoutput, value);
      return resolved.found ? stringifyOutputPathValue(resolved.value) : "";
    } catch {
      return null;
    }
  }
  return null;
}
function formatUdvList(userDefinedVariablesList) {
  const formattedObj = {};
  userDefinedVariablesList.forEach((item) => {
    let value = "";
    try {
      value = JSON.parse(item.value.itemValue);
    } catch (error) {
      value = item.value.itemValue;
    }
    formattedObj[item.value.itemKey] = value;
  });
  return formattedObj;
}
export function getTooltipForUdv(value, userDefinedVariablesList) {
  const pattern = /[^@#]+/g;
  const matches = value.match(pattern);
  let result = formatUdvList(userDefinedVariablesList);
  for (let i = 0; i < matches?.length; i++) {
    if (matches[i] in result) {
      result = result[matches[i]];
    } else {
      result = null;
      break;
    }
  }
  return result;
}
